import React, { FC, PropsWithChildren } from 'react';
import { ModalProps } from '@models/interfaces';
import { Modal } from '../../modules/ui-kit/modal';

import './styles.scss';

export const DeleteModal: FC<ModalProps> = ({
  ...props
}: PropsWithChildren<any>) => (
  <Modal
    okText="Delete"
    cancelText="Cancel"
    className="prov-delete-modal"
    cancelType="danger-outline"
    centered
    {...props}
  >
    <span className="prov-delete-modal__title">
      Do you want to delete this item?
    </span>
  </Modal>
);
